export default {"src":"/_next/static/media/line.7907415d.svg","height":42,"width":54,"blurWidth":0,"blurHeight":0};